import { navigateToHash } from 'JS/global.js';

export default function (to) {
  if (to?.hash) {
    navigateToHash({ hash: to?.hash, delay: 900 }); // scroll to hash when changing routes
  } else {
    navigateToHash({ hash: '#__nuxt', delay: 300 }); // scroll to top when changing routes
  }
}
